import React, { useEffect, useState } from "react";
import {Link, useParams} from "react-router-dom";
import locale from "locale";
import { Button, Checkbox, FormGroup, InputGroup, Modal } from "react-bootstrap";
import FormControlLanguage from "../../../UI/FormControlLanguage";
import ReactSelect from 'react-select';

const DEFAULT_SELECT_VALUE = 'Добавить нового участника';

const ParticipantUpdateModal = (
    {
        isModalVisible,
        members,
        editableMember = null,
        onAddMember,
        onEditMember,
        onClose,
    }
) => {
    const [selectedMember, setSelectedMember] = useState(editableMember?.member ?? null);
    const [model, setModel] = React.useReducer(
        (prev, next) => {
            return { ...prev, ...next };
        },
        {
            important: false,
            showTopic: false,
            topicRu: '',
            topicEn: '',
        },
    );
    const {eventPassword} = useParams();

    useEffect(() => {
        if (editableMember) {
            setSelectedMember(editableMember?.member);
            setModel({important: !!editableMember?.important});
            setModel({showTopic: !!editableMember?.topicRu || !!editableMember?.topicEn});
            setModel({topicRu: editableMember?.topicRu ?? ''});
            setModel({topicEn: editableMember?.topicEn ?? ''});
        }
    }, [editableMember]);

    function handleCloseModal() {
        setSelectedMember(null);
        resetModel();
        onClose();
    }

    function resetModel() {
        setModel({important: false});
        setModel({showTopic: false});
        setModel({topicRu: ''});
        setModel({topicEn: ''});
        setSelectedMember(null);
    }

    function handleSelectMember(memberId) {
        setSelectedMember(members.find(({id}) => id === +memberId));
    }

    function handleSaveMember() {
        if (!editableMember) {
            onAddMember({...selectedMember, ...model});
        } else {
            onEditMember({...editableMember, ...model});
        }

        handleCloseModal();
    }

    return (
        <Modal
            show={isModalVisible}
            onHide={handleCloseModal}
        >
            <Modal.Header>
                <Modal.Title>
                    Добавить участника
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ReactSelect
                    defaultValue={selectedMember?.id ?? ''}
                    name="eventParticipants"
                    options={members.map((member) => ({value: member.id, label: `${locale.field(member, 'lastname')} ${locale.field(member, 'name')}`}))}
                    isDisabled={!!editableMember || !members.length}
                    placeholder={!!members?.length ? DEFAULT_SELECT_VALUE : 'Нет участников с нужным признаком'}
                    onChange={({value}) => handleSelectMember(value)}
                />
                <br />
                <p>
                    <i>
                        Добавить нового участника и отредактировать существующих можно <br />
                        в разделе <Link to={`/event/${eventPassword}/participants`}>участники</Link>
                    </i>
                </p>
                <FormGroup>
                    <Checkbox
                        checked={model.important}
                        name="importantParticipant"
                        onChange={({target}) => setModel({important: target.checked})}
                    >
                        Важный участник
                    </Checkbox>
                </FormGroup>
                <FormGroup>
                    <Checkbox
                        checked={model.showTopic}
                        name="showTopic"
                        onChange={({target}) => setModel({showTopic: target.checked})}
                    >
                        Добавить тему выступления
                    </Checkbox>
                </FormGroup>
                {model.showTopic && (
                    <InputGroup>
                        <InputGroup.Addon>Тема</InputGroup.Addon>
                        <FormControlLanguage
                            type="text"
                            placeholder="Введите тему выступления"
                            values={{
                                ru: model.topicRu,
                                en: model.topicEn,
                            }}
                            onChange={{
                                ru: ({target}) => setModel({topicRu: target.value}),
                                en: ({target}) => setModel({topicEn: target.value}),
                            }}
                        />
                    </InputGroup>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleSaveMember}>
                    Сохранить
                </Button>
                <Button onClick={handleCloseModal}>
                    Отменить
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ParticipantUpdateModal;
